import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo(title, description) {
  useEffect(() => {
    const full = title ? `${title} | NicaFix` : "NicaFix";
    document.title = full;
    setMeta("property", "og:title", full);
    setMeta("name", "twitter:title", full);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
  }, [title, description]);
}
